import { createFileRoute } from "@tanstack/react-router";

import { OtpPhonePage } from "@/components/Pages";

export const Route = createFileRoute("/_auth/otp/")({
  component: OtpPhonePage,
});
